export default function() {
    // String formatter
    String.prototype.format = function(...args) {
        var t
        if (args.length == 1 && Array.isArray(args[0])) t = args[0]
        else t = args
        return this.replace(/{([0-9]+)}/g, function(match, index) {
            return typeof t[index] == 'undefined' ? match : t[index]
        })
    }

    // Chain if-else
    // Object.prototype.if = function(condition = false) {
    //     if (!this) return this

    //     let status = false
    //     if (typeof condition == 'function' && !!condition(this)) {
    //         status = true
    //     } else if (!!condition) {
    //         status = true
    //     }

    //     this.result = this
    //     this.status = status

    //     this.then = func => {
    //         if (this.status) this.result = func(this)
    //         delete this.then
    //         return this
    //     }
    //     this.else = func => {
    //         if (!this.status) this.result = func(this)
    //         delete this.else
    //         return this
    //     }
    // }
}